import { h, Component } from "preact";
import { fsClient, getImageUrl, loadScripts } from "../services/ImageService";
import imageIcon from "../assets/images/ic_image.svg";
import Image from "../components/Image";

class ImageUpload extends Component {
  constructor() {
    super();
    this.state = { scriptsLoad: false };
  }

  componentDidMount() {
    loadScripts().then(() => {
      this.setState({ scriptsLoad: true });
    });
  }

  render(props) {
    const { scriptsLoad } = this.state;
    const image = props.value;
    let {
      aspectRatio = 1,
      uploadLabel,
      uploadDescription,
      uploadOutsideDescription = ""
    } = props;
    uploadLabel = uploadLabel ? uploadLabel : "Upload an image";
    uploadDescription = uploadDescription
      ? uploadDescription
      : "Images should be smaller than 10 mb";
    let padding = 100 / aspectRatio;
    padding = padding > 50 ? 50 : padding;
    const url = image ? getImageUrl(image, 800) : image;
    const styles = {
      imageArea: {
        background: image ? `url(${url}) no-repeat` : "transparent",
        backgroundSize: "contain",
        backgroundPosition: "center",
        width: "100%",
        paddingTop: `${padding}%`,
        border: !image ? "1px dashed #d9d9d9" : "none",
        position: "relative",
        textAlign: "center",
        cursor: "pointer"
      },
      noImage: {
        position: "absolute",
        top: "calc(50% - 75px)",
        bottom: 0,
        left: 0,
        right: 0,
        height: 150,
        textAlign: "center"
      },
      icon: {
        fontSize: "90px",
        color: "#eee",
        margin: 0,
        lineHeight: 1.2
      },
      text: {
        fontSize: "16px",
        margin: "0 0 4px"
      },
      hint: {
        fontSize: "14px",
        color: "#323232",
        marginTop: 15
      },
      buttonRow: {
        marginTop: 10,
        textAlign: "center"
      }
    };

    if (!scriptsLoad) {
      return (
        <div style={{ ...styles.imageArea, padding: 0 }}>
          <div
            class="loading loading-lg"
            style={{ margin: "80px 0", display: "block" }}
          />
        </div>
      );
    }
    const uploadImage = () => {
      const { aspectRatio } = props;
      const options = {
        fromSources: [
          "local_file_system",
          "url",
          "facebook",
          "instagram",
          "googledrive",
          "dropbox",
          "evernote",
          "flickr"
        ],
        maxSize: 102400000,
        maxFiles: 1,
        minFiles: 1,
        imageMax: [1000, 1000],
        uploadInBackground: false,
        transformations: {
          crop: true,
          rotate: true
        },
        accept: ["image/*"],
        onUploadDone: imageUploaded
      };
      fsClient.picker(options).open();
    };

    const editImage = () => {
      const image = props.value;
      const aspectRatio = props.aspectRatio;
      const options = {
        transformations: {
          crop: {
            force: true,
            aspectRatio: aspectRatio
          },
          rotate: true
        },
        accept: ["image/*"],
        onUploadDone: imageUploaded
      };
      fsClient.picker(options).crop(image.url);
    };

    const imageUploaded = ({ filesUploaded, filesFailed }) => {
      const { onChange } = props;
      if (filesFailed.length) {
        message.error("Image failed to upload");
        return;
      }
      const uploadedImage = filesUploaded[0];
      const image = {
        name: uploadedImage.filename,
        size: uploadedImage.size,
        url: uploadedImage.url,
        source: uploadedImage.source,
        handle: uploadedImage.handle
      };

      if (onChange) {
        onChange(image);
      }
    };

    return (
      <div>
        <div style={styles.imageArea} onClick={uploadImage}>
          {!image ? (
            <div style={styles.noImage}>
              <p style={styles.icon}>
                <Image src={imageIcon} alt="Image upload icon" />
              </p>
              <button
                type="button"
                class="btn btn-primary btn-lg"
                style={styles.button}
                aria-label="upload"
                aria-hidden={true}
              >
                {uploadLabel}
              </button>
              <p style={styles.hint}>{uploadDescription}</p>
            </div>
          ) : (
            ""
          )}
        </div>
        {image ? (
          <div style={styles.buttonRow}>
            <button
              type="button"
              class="btn btn-lg"
              onClick={editImage}
              aria-label="edit"
            >
              Edit
            </button>{" "}
            <button
              type="button"
              class="btn btn-lg"
              onClick={uploadImage}
              aria-label="upload"
            >
              Upload
            </button>
          </div>
        ) : (
          ""
        )}
        <p style={styles.hint}>{uploadOutsideDescription}</p>
      </div>
    );
  }
}

export default ImageUpload;



// WEBPACK FOOTER //
// ./components/ImageUpload.js